<template>
  <div class="min-h-screen overflow-y-auto bg-gray-50 px-4 py-10" dir="rtl">
    <div class="max-w-lg mx-auto flex flex-col justify-between">
      <div
        ref="form"
      >
        <div>
          <ul class="info-list">
            <!--            *****************************-->
            <li class="info-item">
              <label>دسته بندی</label>
              <span>
                  {{request_info.type_name}} {{request_info.group_name}} {{request_info.subgroup_name}}
              </span>
            </li>
            <hr>
            <li class="info-item">
              <label>مدل دستگاه</label>
              <span>
                {{request_info.device_model}}
              </span>
            </li>
            <hr>

            <!--            *****************************-->
            <li class="info-item">
              <label>نام مشتری</label>

              <span>
                {{request_info.customer}}
              </span>
            </li>
            <hr>

            <li class="info-item">
              <label>شماره موبایل مشتری</label>
              <span>
                {{request_info.customer_mobile}}
              </span>
            </li>
            <hr>

            <li class="info-item">
              <label>توضیحات درخواست</label>

            </li>
            <li class="info-item">
              <span>
                {{request_info.summary}}
              </span>
            </li>
            <hr>

            <li class="info-item">
              <label>زمان باقیمانده تا پذیرش {{remaining_time}} ثانیه</label>
              <div class="progress">
                <div class="progress-bar" :style="{ width: (remaining_time/120*100) + '%' }"></div>
              </div>
            </li>

          </ul>
        </div>
        <div>
          <div :style="{ height: '250px'}" id='map2'></div>
        </div>
        <div class="actions-row">
          <button class="btn-accept w-100"  @click="accept_online_request_refer_dialog=true">
            پذیرش درخواست
          </button>
          <button class="btn-reject w-100" @click="openCancelDialog()">
            لغو درخواست
          </button>
        </div>
      </div>
      <div v-if="cancel_online_request_refer_dialog" class="plain-dialog">
        <div class="dialog-card">
          <button class="dialog-close" @click="cancel_online_request_refer_dialog=false">×</button>
          <div class="dialog-header">لغو درخواست</div>
          <div class="dialog-body">
            <div class="mb-2">
              <select v-model="selected_status_for_change" class="plain-input">
                <option :value="0" disabled>دلیل لغو</option>
                <option v-for="opt in status_list_items" :key="opt.value" :value="opt.value">{{ opt.label }}</option>
              </select>
            </div>
            <textarea
              rows="3"
              v-model="change_status_summary"
              class="plain-input"
              placeholder="توضیحات دلیل لغو را وارد کنید"
            ></textarea>
          </div>
          <div class="dialog-actions">
            <button
              class="btn-reject"
              :disabled="!canSubmitCancel"
              @click="cancel_online_request()"
            >{{$t('ok')}}</button>
          </div>
        </div>
      </div>

      <div v-if="accept_online_request_refer_dialog" class="plain-dialog">
        <div class="dialog-card">
          <button class="dialog-close" @click="accept_online_request_refer_dialog=false">×</button>
          <div class="dialog-header">قبول درخواست</div>
          <div class="dialog-body">
            <textarea rows="2" v-model="change_status_summary" class="plain-input" :placeholder="$t('insertChangeStatusSummary')"></textarea>
          </div>
          <div class="dialog-actions">
            <button class="btn-accept" @click="accept_online_request()">{{$t('ok')}}</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import {bus} from '../../main.js'

  export default {
    props: [
      'passing_data'
    ],
    data() {
      return {
        cancel_online_request_refer_dialog:false,
        accept_online_request_refer_dialog:false,
        remaining_time:120,
        remaining_time_timer:null,
        change_status_summary:'',
        change_status_dialog:false,
        status_list_items: [],
        selected_status_for_change: 0,
        errors: [],
        request_info: {},
        action_button_text: '',
        request_statuses: [],
        next_action_status: 0,
        branch_id: 0,

        technician_name: 'hamid mokhtari',
        device_password: 'hamid mokhtari',
        user_location_lat:null,
        user_location_lng:null,
        map: null,
        polygon_area: [
          [-67.13734351262877, 45.137451890638886],
          [-66.96466, 44.8097],
          [-68.03252, 44.3252],
          [-69.06, 43.98],
          [-70.11617, 43.68405],

        ],
        first_map:true,
      }
    },
    computed: {
      canSubmitCancel () {
        return this.selected_status_for_change != 0 &&
          String(this.change_status_summary || '').trim() !== ''
      }
    },
    watch: {
      selected_province: function () {
        this.get_cities()
      }
    },
    mounted() {
      this.request_info = JSON.parse(localStorage.getItem("online_request_refer_data"))
      this.set_remaining_time()
      this.user_location_lat = this.request_info.lat;
      this.user_location_lng = this.request_info.lng;
      setTimeout(() => {

        this.createMap()
      }, 1000);
      // var passing_data = JSON.parse(localStorage.getItem('request_data'));
      // this.enable_send_from_country = passing_data.on_site_service;
      // this.get_phone_prefix()
      // this.get_device_status()
      // this.get_provinces()
      this.get_stats_list()
    },
    methods: {
      openCancelDialog () {
        this.change_status_summary = ''
        this.cancel_online_request_refer_dialog = true
      },
      set_remaining_time(){
        this.remaining_time_timer = setTimeout(() => {
          this.remaining_time--;
          if(this.remaining_time<=0){
            this.selected_status_for_change = this.status_list_items[this.status_list_items.length-1].value;
            this.change_status_summary= "اتمام زمان"
            this.cancel_online_request()
          }else {
            this.set_remaining_time()
          }
        }, 1000)
      },
      get_stats_list() {
        var self = this
        var user_id = JSON.parse(localStorage.getItem('profile')).UserId
        // const send_data = {
        //   ExpertId: user_id,
        //   RequestId: this.$route.params.rec_id,
        // }
        var formData = new FormData();
        formData.append('ExpertId',user_id);
        formData.append('RequestId',this.$route.params.rec_id);
        // this.axios.post('/Register' , send_data,{
        this.axios.post('https://cp.zoodkomak.com/api/refer_request_status', formData, {})
          .then(response => {
              response.data.data.forEach(function (number) {
                var obj = {value: number.id, label: number.title}
                self.status_list_items.push(obj)
              })
              self.selected_status_for_change = self.status_list_items[0].value;

          }).catch(e => {
          this.errors.push(e)
        })
      },
      cancel_online_request() {
        var self = this;
        if (!this.canSubmitCancel && this.remaining_time > 0) {
          bus.$emit('show_toast', [2000, 'توضیحات دلیل لغو را وارد کنید'])
          return
        }
        const send_data = {
          mobile: localStorage.getItem("phone").replace("+98","0"),
          request_id: this.request_info.id,
          status_id: this.selected_status_for_change,
          summary: String(this.change_status_summary || '').trim(),
        }
        this.cancel_online_request_refer_dialog = false

        // this.axios.post('/Register' , send_data,{
        this.axios.post('https://cp.zoodkomak.com/api/cancel_online_request_refer', send_data, {})
          .then(response => {
            bus.$emit('show_toast', [2000, response.data.msg])
            clearTimeout(this.remaining_time_timer)
            self.$router.push({ path: "/home-tab", params: {} });
          }).catch(e => {
          this.errors.push(e)
        })
      },
      accept_online_request() {
        var self = this;
        const send_data = {
          mobile: localStorage.getItem("phone").replace("+98","0"),
          request_id: this.request_info.id,
          status_id: this.status_list_items[this.status_list_items.length-1].value,
          summary: this.change_status_summary,
        }
        this.accept_online_request_refer_dialog = false
        // this.axios.post('/Register' , send_data,{
        this.axios.post('https://cp.zoodkomak.com/api/accept_online_request_refer', send_data, {})
          .then(response => {
            bus.$emit('show_toast', [2000, response.data.msg])
            clearTimeout(this.remaining_time_timer)

            self.$router.push({ path: "/home-tab", params: {} });
          }).catch(e => {
          this.errors.push(e)
        })
      },
      createMap() {
        var self = this;
        // init the map
        mapboxgl.accessToken = 'pk.eyJ1Ijoib21kZXNobyIsImEiOiJjanoyaW1zNG4wMHI1M2JteTQyZXhqaTI3In0.M0GJxZnal_ysW7mxXWEZLg';
        try{
          if(this.first_map) {
            mapboxgl.setRTLTextPlugin(
              'https://api.mapbox.com/mapbox-gl-js/plugins/mapbox-gl-rtl-text/v0.2.3/mapbox-gl-rtl-text.js',
              null,
              true // Lazy load the plugin
            );
            this.first_map = false;
          }
        }catch (e) {

        }

        var center_loc = [this.user_location_lng, this.user_location_lat];

        self.map = new mapboxgl.Map({
          container: 'map2',
          style: 'mapbox://styles/mapbox/streets-v11', // stylesheet location
          center: center_loc,
          zoom: 14 // starting zoom
        });
        var latlng = new mapboxgl.LngLat(this.user_location_lng,this.user_location_lat);
        self.map.resize();
        self.marker = new mapboxgl.Marker({
          draggable: true
        })

          .setLngLat(latlng)
          .addTo(self.map);

        // self.polygon_draw = new MapboxDraw({
        //   displayControlsDefault: false,
        //   controls: {
        //     polygon: true,
        //     trash: true
        //   }
        // });

        // self.map.addControl(self.polygon_draw);
        // self.map.on('draw.create', self.updatePolygonArea);
        // self.map.on('draw.delete', self.updatePolygonArea);
        // self.map.on('draw.update', self.updatePolygonArea);

        // self.map.addControl(new mapboxgl.Navigation())
        // self.map.on('click', function (e) {
        //   if (self.marker != null) {
        //     self.marker.remove();
        //   }
        //   // if (self.user_location_lat == 0) {
        //
        //   self.marker = new mapboxgl.Marker({
        //     draggable: true
        //   })
        //
        //     .setLngLat(e.lngLat)
        //     .addTo(self.map);
        //   self.user_location_lat = e.lngLat.lat;
        //   self.user_location_lng = e.lngLat.lng;
        //
        //   // }
        //
        //   function onDragEnd() {
        //     // var lngLat = marker.getLngLat();
        //     self.user_location_lat = self.marker.getLngLat().lat;
        //     self.user_location_lng = self.marker.getLngLat().lng;
        //
        //   }
        //
        //   function onDragStart() {
        //     // var lngLat = marker.getLngLat();
        //     console.log("drag started");
        //     self.user_location_lat = self.marker.getLngLat().lat;
        //     self.user_location_lng = self.marker.getLngLat().lng;
        //
        //   }
        //
        //   self.marker.on('dragend', onDragEnd);
        //   self.marker.on('dragstart', onDragStart);
        //   console.log('A click event has occurred at ' + e.lngLat);
        //   // }
        //
        // });

        self.map.on('load', function () {
          // self.show_polygon();
          self.map.resize();
          console.log("map loaded")
        });
      },
      updatePolygonArea() {
        var data = this.polygon_draw.getAll();
        // console.log(data);
        if (data.features.length > 0) {
          this.polygon_area = data.features[0].geometry.coordinates;
          this.show_polygon();

        } else {
          this.polygon_area = [];
          this.show_polygon();

        }
      },
      show_polygon() {

        this.map.addSource('maine', {
          'type': 'geojson',
          'data': {
            'type': 'Feature',
            'geometry': {
              'type': 'Polygon',
              'coordinates': this.polygon_area

            }
          }
        });
        this.map.addLayer({
          'id': 'maine',
          'type': 'fill',
          'source': 'maine',
          'layout': {},
          'paint': {
            'fill-color': '#088',
            'fill-opacity': 0.8
          }
        });


      },
    },

  }
</script>
<style scoped>
.view-req-detail { background: #f8fafc; padding: 12px; }
.info-list { list-style: none; padding: 0; margin: 0 0 12px 0; }
.info-item { display:flex; justify-content:space-between; align-items:center; background:#fff; border:1px solid #e5e7eb; border-radius:12px; padding:12px 14px; margin-bottom:8px; }
.info-item label { color:#475569; font-size:13px; }
.info-item span { color:#0f172a; font-size:13px; }
.progress { width: 100%; height: 8px; border-radius: 999px; overflow: hidden; }
.progress-bar { height: 100%; background: linear-gradient(90deg,#60a5fa,#2563eb); }
.actions-row { display:grid; grid-template-columns: 1fr 1fr; gap: 10px; margin: 12px 0; }
.w-100 { width: 100%; }

/* Dialog */
.plain-dialog { position: fixed; inset: 0; background: rgba(0,0,0,.35); display:flex; align-items:center; justify-content:center; z-index:999; }
.dialog-card { width: 92%; max-width: 520px; background:#fff; border-radius:16px; box-shadow:0 20px 40px rgba(0,0,0,.18); overflow:hidden; position:relative; }
.dialog-close { position:absolute; top:8px; right:10px; width:32px; height:32px; border:none; background:transparent; color:#64748b; font-size:24px; line-height:32px; cursor:pointer; }
.dialog-close:hover { color:#0f172a; }
.dialog-header { padding:12px 16px; border-bottom:1px solid #e5e7eb; font-weight:700; text-align:center; }
.dialog-body { padding: 12px 16px; }
.dialog-actions { padding: 12px 16px; display:flex; justify-content:center; gap:8px; }
.plain-input { width:100%; min-height:48px; background:#fff; border:1px solid #e5e7eb; border-radius:10px; padding:10px 12px; font-size:14px; color:#0f172a; }
textarea.plain-input { min-height: 80px; }

.btn-accept { padding:10px 14px; background:linear-gradient(135deg,#1c39bb 0%,#2563eb 100%); color:#fff; border:none; border-radius:10px; font-weight:600; }
.btn-reject { padding:10px 14px; background:linear-gradient(135deg,#ef4444 0%, #dc2626 100%); color:#fff; border:none; border-radius:10px; font-weight:600; }
.btn-accept:disabled, .btn-reject:disabled { opacity:.6; }
</style>
